import { AfterViewInit, Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InventoryService } from '@wb/core/services/inventory.service';
import { AnalyticService } from '@wb/core/services/analytic.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-vehicle-id-dialog',
  templateUrl: './vehicle-id-dialog.component.html',
  styleUrls: ['./vehicle-id-dialog.component.sass'],
})
export class VehicleIdDialogComponent implements OnDestroy, AfterViewInit {
  @Output() save: EventEmitter<void> = new EventEmitter();

  @Output() emitReloadEvent: EventEmitter<number> = new EventEmitter<number>();

  formGroup: FormGroup = new FormGroup({
    market_scan_id: new FormControl(null),
  });

  isLoadingData: boolean = true;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { uid: string; marketscan_id: number; inventory: InventoryService },
    public dialogRef: MatDialogRef<VehicleIdDialogComponent>,
    private inventoryService: InventoryService,
    private readonly snackBar: MatSnackBar,
    private readonly translate: TranslateService,
    private analytics: AnalyticService,
  ) {
    this.isLoadingData = false;
  }

  ngAfterViewInit() {
    this.formGroup.patchValue({ market_scan_id: this.data.marketscan_id ?? '' });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  async idSearch() {
    this.inventoryService.searchMarketScanId(this.data.uid as string).then((response: any) => {
      if (response?.searchMarketScanVehicleId?.success) {
        if (response.searchMarketScanVehicleId?.data) {
          this.formGroup.patchValue({ market_scan_id: response.searchMarketScanVehicleId?.data });
          return;
        }
      }
      this.snackBar.open(this.translate.instant('marketScanId.error'), '', { duration: 3000 });
    });
    this.analytics.track({ object: 'Inventory', action: 'Click', properties: { type: 'market_scan_id_search' } });
  }

  async onSubmit() {
    const marketScanId: number = this.formGroup.value.market_scan_id ? +this.formGroup.value.market_scan_id : 0;
    this.inventoryService.resetMarketScanId(this.data.uid as string, marketScanId).then((response) => {
      if (!(response instanceof HttpErrorResponse)) {
        this.emitReloadEvent.emit(marketScanId);
        this.dialogRef.close(true);
      }
    });
    this.analytics.track({ object: 'Inventory', action: 'Click', properties: { type: 'market_scan_id_reset' } });
  }
}
